import { Dayjs } from "dayjs"
import { ICoreMeterpoint } from "./coreMeterpoint.types"
import { getSupplyStatus } from "@/helpers/meterpointHelper"

export class CoreMeterpoint implements ICoreMeterpoint {
  id: number
  identifier: string
  meterpointType: string
  supplyStatus: string
  supplyStartDate: Dayjs
  gspGroup: string
  profileClass: string

  constructor(
    id: number,
    identifier: string,
    meterpointType: string,
    supplyStatus: string,
    supplyStartDate: Dayjs,
    profileClass: string,
    gspGroup: string,
  ) {
    this.id = id
    this.identifier = identifier
    this.meterpointType = meterpointType
    this.gspGroup = gspGroup
    this.profileClass = profileClass
    this.supplyStatus = supplyStatus
    this.supplyStartDate = supplyStartDate
  }

  get status() {
    return getSupplyStatus(this.supplyStatus)
  }
}
